export const environment = {
    production: true,
    environment:"demo",
    customerName: "Omnicell Health System",
    envType:"internal",
    apiUrl : "https://demo-api.diversion.myomnicell.com/",
    enableItemsOfInterest: true,
    disableWitnessAuth: true,
    disablePincodeUpdate: true,
    enableLocalTestAuth: true,
    enabledStockAreaConfig:true,
    enableConfigurationManagement: false,
    enableNotificationManagement: true,

      /* Okta Auth */
     okta:{
        clientId: '0oa125xf7nbDcYm6s298',
        issuer: 'https://omnicellexternal.okta.com/oauth2/default',
        redirectUri: 'https://demo.diversion.myomnicell.com/login/callback',
        scopes: ['openid', 'profile', 'email'],
        pkce: true,
        idp: undefined,
        loginHint: undefined,
        externalIdpId:undefined
      },
    assets: "/assets/anigent",
    appUrl: "https://demo.diversion.myomnicell.com/",
    isCameraLoginFeatureEnabled:true,
    userEmail: [
      "faheem@kaleitics.com",
      "Fabella.Jun@mayo.edu",
      "Johnson.Tim@mayo.edu",
      "DAmato.Charles@mayo.edu",
      "Fink.Mike@mayo.edu",
      "Crouse.Joe@mayo.edu",
      "mfink@anigent.com",
      "mfink@anigent.com",
      "jfabella@anigent.com",
      "cdamato@anigent.com"
    ],
    p2pReportId:"7202f6c8-f16c-427d-a064-4576d9467c80",
    lockDuration:60000,
    logoFile: "ANiGENT-logo.png",
    userAuthVersion:"v4",
    version:4.1,
    enableAssayManagement: true,
    wasteActive: true,
    footprint:'small',
    include_csn:false,
    convert_times: true,
    telemetry: {
      appInsights: {
        enabled: true,
        connectionString: ''
      }
    }
  };
